import React, { useContext} from 'react'
import {
 useLocation
} from "react-router-dom";
import moment from 'moment';
import Language from '../../Context/Language';

export default function ModalPlayerStatics({ModalCole , PlayerStaticData , PlayerProfile ,HomeTeamName , HomeTeamId  }) {



  const AgeCount = (yas) => {
   return ( (moment().year()) - yas).toFixed(0);
  }


  function addDefaultSrc(ev){
   ev.target.src = '/CountryFlag/world.png'
 }


  const location = useLocation()
  const dataLang = useContext(Language)
  return (
    <div className='ModalPlayerStaticsContainer'>
        <div className='ModalPlayerStaticArea'>
            <div className='ModalPlayerImagePLayerContainer'>
                <div className='ModalPlayerAndImage'>
                <img  src={`https://cdn-images.nvpark.com/logo/${HomeTeamId}.png`}  width={40} height={40}></img>
                 <div>{HomeTeamName}</div>
                </div>
                 <img className='PlayerStaticsCloseButton' onClick={ModalCole} src='/close-button.png' width={30} height={30}></img>
            </div>
            <div className='PlayerStaticArea'>
               <div className='PlayerStaticProfileArea'>
                <div className='PlayerStaticPlayerClubAndName'>
                <img className='PlayerStaticCountryFlag' src={`/CountryFlag/${PlayerProfile.nationality === "Bosnia & herzegovina" ? "BosniaHerzegowina" :PlayerProfile.nationality === "England" ? "UnitedKingsom" : PlayerProfile.nationality ==="Hungary" ? "Hungaria" :PlayerProfile.nationality ==="Denmark" ? "Danmark" :PlayerProfile.nationality ==="North macedonia" ? "Mazedonia":PlayerProfile.nationality}.png`} onError={addDefaultSrc}  width={45} height={45}></img>
                <div className='PlayerStaticCountry'>
                <div className='PlayerStaticPlayerName'>{PlayerProfile.name}</div>
                <div className='PlayerStaticPlayerAge'>{dataLang[sessionStorage.getItem("lang")].Age } {AgeCount(PlayerProfile.date_of_birth.split(" ")[0].split("/").pop())} ({PlayerProfile.date_of_birth.split(" ")[0]}) </div>
                </div>
              
                </div>
                <div className='PlayerPropertiesArea'>
                 <div className='PlayerPropertiesFirstCon'>
                 </div>
                 <div className='PlayerPropertiesSecondCon'>
                 <div className='PlayerProp'>
                    <div className='PlayerPropHead'>{dataLang[sessionStorage.getItem("lang")].type}:</div>
                    <div className='PlayerPropValue'>{PlayerProfile.type}</div>
                  </div>
                  <div className='PlayerProp'>
                    <div className='PlayerPropHead'>{dataLang[sessionStorage.getItem("lang")].nationality}:</div>
                    <div className='PlayerPropValue'>{PlayerProfile.nationality}</div>
                  </div>
                </div>
                </div>
               </div>
               <div className='PlayerStaticMatch'>
                <div className='PlayerStaticMatchFirst'>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{PlayerProfile.type ==="goalkeeper" ? dataLang[sessionStorage.getItem("lang")].Minute :dataLang[sessionStorage.getItem("lang")].Minute }</div>
                   <div className='PlayerStaticPropValue'>{PlayerProfile.type ==="goalkeeper" ? PlayerStaticData.minutesPlayed : PlayerStaticData.minutesPlayed}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{PlayerProfile.type ==="goalkeeper" ? dataLang[sessionStorage.getItem("lang")].GoalKeeperSave :dataLang[sessionStorage.getItem("lang")].Offside}</div>
                   <div className='PlayerStaticPropValue'>{PlayerProfile.type ==="goalkeeper" ? PlayerStaticData.saves : PlayerStaticData.offsides}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].Goal}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.goals}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].assists}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.assists}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].ShotonTarget}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.shotsOnTarget}</div>
                </div>
                </div>
                <div className='PlayerStaticMatchFirst'>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].Foul}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.fouls}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].freekicks}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.freeKickGoal}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].Passes}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.totalPass}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].YellowCard}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.yellowCards}</div>
                </div>
                <div className='PlayerStaticProp'>
                   <div className='PlayerStaticPropHeader'>{dataLang[sessionStorage.getItem("lang")].RedCard}:</div>
                   <div className='PlayerStaticPropValue'>{PlayerStaticData.redCards}</div>
                </div>

                </div>
               </div>
            </div>
        </div>
    </div>
  )
}
